import { render, staticRenderFns } from "./4.vue?vue&type=template&id=06b813fa&scoped=true&"
var script = {}
import style0 from "./4.vue?vue&type=style&index=0&id=06b813fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b813fa",
  null
  
)

export default component.exports